<template lang="pug">
.v-tile-slider.tile-slider
	v-loader(:loading="!swiper")
	.tile-slider__wrap
		.tile-slider__content
			h3.tile-slider__title(v-if="data && data.title" :class="data?.titleStyleLevel") {{ data.title }}
			.tile-slider__body
				.tile-slider__buttons(v-if="!isSm")
					button.tile-slider__button.detail-slider-btn.left(ref="prev")
					button.tile-slider__button.detail-slider-btn.right(ref="next")
				v-swiper-slider(v-if="data && data.items && data.items.length"
					:options="{...options, freeMode: isSm}"
					:navigation="!isSm ? navigation : false"
					@swiper="onSwiper")
					swiper-slide.collection-slider__slide(v-for="(item, index) in data.items" :key="index")
						.tile-item
							a.tile-item__link(
								v-if="item.link && item.link.href"
								:href="item.link.href"
								)
							img.tile-item__visual(
								v-if="item.image && item.image.src"
								:src="item.image.src"
								:alt="item.image.src"
								)
							.tile-item__body
								.tile-item__name(v-if="item.title") {{item.title}}
								.tile-item__info(v-if="item.height && item.width")
									span.tile-item__info-height {{item.height}}
									span.tile-item__info-separator x
									span.tile-item__info-width {{item.width}}
									span.tile-item__info-desc(v-if="item.desc") {{item.desc}}
		.tile-slider__colors(v-if="data.collections")
			.tile-slider__colors-title(v-if="data.collectionLabel") {{data.collectionLabel}}
			.tile-slider__colors-subtitle(v-if="data.collectionSubtitle") {{data.collectionSubtitle}}
			.tile-slider__colors-grid
				template(v-for="(item, index) in data.collections" :key="index" )
					.tile-slider__colors-item
						a.offer-item(:class="{'offer-item--active' : item.active}" :href="item.link")
							.offers-item__img(v-if="item.preview" :style="{backgroundColor: item.preview}")
</template>

<script>
	import sourceMixin from '../components/mixins/v-mixin-source.vue';
	import isMobMixin from '../components/mixins/v-mixin-is-mob.vue'
	import breakpoints from '../scripts/breakpoints.js';
	import uniqueId from '../scripts/helpers/uniqueId.js';
	import {SwiperSlide} from "swiper/vue";

	export default {
		components: {
			SwiperSlide,
		},

		mixins: [
			sourceMixin,
			isMobMixin
		],
		data() {
			return {
				data: {},
				swiper: null,
				uniqueId: uniqueId('swiper-'),
				options: {
					slidesPerView: 10,
					spaceBetween: 14,
					a11y: {
						prevSlideMessage: 'Предыдущий слайд',
						nextSlideMessage: 'Следующий слайд',
					},
					breakpoints: {
						[breakpoints['lg-max']]: {
							slidesPerView: 8
						},
						[breakpoints['md-max']]: {
							slidesPerView: 6
						},
						[breakpoints['sm-max']]: {
							slidesPerView: 4
						},
						[breakpoints['4xs-min']]: {
							slidesPerView: "auto"
						}
					},
					navigation: false
				}
			}
		},
		methods: {
			dataSet(data) {
				this.data = data;
			},
			onSwiper(swiper) {
				this.navigation = {
					prevEl: this.$refs['prev'],
					nextEl: this.$refs['next']
				};
				this.swiper = swiper;
			}
		}
	}

</script>